import { QueryClientProvider } from '@tanstack/react-query'

import { ProductDetails } from './ProductDetails'
import { getQueryClient } from '../../../../Infrastructure'
import { CheckoutProvider } from '../../../Checkout'
import { ReviewsProvider } from '../../../Reviews'
import { UiProvider } from '../../../Theme'
import { WishlistProvider } from '../../../Wishlist'
import { ProductProvider, RelatedProductsProvider } from '../../state'

import type { ProductViewProps } from '../../types'

const queryClient = getQueryClient()

export function ProductView({ productSku }: ProductViewProps) {
  return (
    <QueryClientProvider client={queryClient}>
      <UiProvider>
        <CheckoutProvider>
          <WishlistProvider>
            <ProductProvider productSku={productSku}>
              <RelatedProductsProvider productSku={productSku}>
                <ReviewsProvider productSku={productSku}>
                  <ProductDetails />
                </ReviewsProvider>
              </RelatedProductsProvider>
            </ProductProvider>
          </WishlistProvider>
        </CheckoutProvider>
      </UiProvider>
    </QueryClientProvider>
  )
}
